<ng-container *transloco="let t">

  <div class="admin-card">
    <app-admin-actions-header (onExportToXls)="exportRequestsList('xlsx')" (onExportToPdf)="exportRequestsList('pdf')">
      <div slot="leadingWidgets" class="d-flex flex-column flex-md-row">
        <div class="d-flex flex-column flex-md-row">
          <div class="w-180 d-flex align-items-center">
            <app-select [hasDefault]="true" [items]="statuses" [ngModel]="selectedStatus" [defaultValue]="undefined"
                        [defaultLabel]="t('app.common.all')" class="me-2 mb-md-0 mb-2" [valueKey]="'id'"
                        [labelKey]="'id'" labelKeyPrefix="request.status." (ngModelChange)="onStatusSelect($event)" [leftAlign]="true"
                        [fullWidthDropdown]="true"/>
          </div>
          @if (authenticationService.isAdmin()) {
            <div class="w-180 d-flex align-items-center">
              <app-select [hasDefault]="true" [items]="types" [ngModel]="selectedType" class="me-2 mb-md-0 mb-2"
                          [defaultValue]="undefined" [defaultLabel]="t('app.common.all')" [valueKey]="'id'"
                          [labelKey]="'id'" labelKeyPrefix="request.type." (ngModelChange)="onTypeSelect($event)" [leftAlign]="true"
                          [fullWidthDropdown]="true"/>
            </div>
          }
        </div>
      </div>
    </app-admin-actions-header>
    <app-loader [isLoading]="isLoading"></app-loader>
    @if (requests.length > 0) {
      <div>
        <div class="table-responsive dark-header d-xl-block d-none">
          <table class="table table-last-row-no-border">
            <thead>
            <tr>
              <th class="user-column-width">{{ t("request.user") }}</th>
              <th class="category-column-width">{{ t("request.category") }}</th>
              <!--              <th>{{ t("request.organiser.name") }}</th>-->
              <th> {{ t("event.item.name") }}</th>
              <th class="date-column-width">{{ t("request.date.created") }}</th>
              <th class="status-column-width">{{ t("request.status") }}</th>
              <th class="more-column-width"></th>
            </tr>
            </thead>
            <tr app-table-header-separator></tr>
            <tbody>
              @for (request of requests; track request) {
                <tr>
                  <td class="center-align">
                    <div *ngTemplateOutlet="userAvatarTemplate; context: {user: request.userDetail}"></div>
                  </td>
                  <td class="center-align">
                    <div class="status-badge"
                         [ngClass]="{'on-hold': request.type === 0 , 'accepted': request.type === 1, 'publishing':
                         request.type === 2}">
                  <span>
                    {{ t("request.type." + request.type) | uppercase }}
                  </span>
                    </div>
                  </td>
<!--                  <td class="center-align">-->
<!--                    {{ getOrganiserNameColumn(request) }}-->
<!--                  </td>-->
                  <td class="center-align">
                    @if (request.event) {
                      <app-language-output [hrLabel]="request.event?.name" [enLabel]="request.event?.nameEng"
                                           [itLabel]="request.event?.nameIta" [siLabel]="request.event?.nameSlo"
                                           [defaultLanguage]="request.event?.defaultLanguage" [languages]="languages"/>
                    } @else {
                      {{ "" }}
                    }
                  </td>

                  <td class="center-align">{{ request.created| localizedDate:'short' }}</td>
                  <td class="center-align">
                    <div class="status-badge"
                         [ngClass]="{'on-hold': request.requestStatus === 0 , 'accepted': request.requestStatus === 1, 'denied': request.requestStatus === 2 }">
                  <span>
                    {{ t("request.status." + request.requestStatus) | uppercase }}
                  </span>
                    </div>
                  </td>
                  <td class="text-end center-align">
                    @if (request.type !== RequestTypes.ADD_EVENT_TO_LEAGUE || actionsAllowed(request)) {
                      <div ngbDropdown class="dropdown dropdown--remove-arrow" container="body">
                  <span class="menu-icon" id="requestActionsDropdown" ngbDropdownToggle>
                    <i class="fas fa-ellipsis-v"></i>
                  </span>
                        <ul aria-labelledby="requestActionsDropdown" ngbDropdownMenu>
                          @if (request.type !== RequestTypes.ADD_EVENT_TO_LEAGUE) {
                            <li ngbDropdownItem (click)="openRequestDetails(request)">
                              {{ t("app.common.details") }}
                            </li>
                          }
                          @if (actionsAllowed(request)) {
                            <li ngbDropdownItem (click)="openModifyRequestDialog(request, true)">
                              {{ t("request.action.accept") }}
                            </li>
                          }
                          @if (actionsAllowed(request)) {
                            <li ngbDropdownItem (click)="openModifyRequestDialog(request, false)">
                              {{ t("request.action.decline") }}
                            </li>
                          }
                        </ul>
                      </div>
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        <!--      Mobile table-->
        @for (request of requests; let isLast = $last; track request) {
          <div class="d-block d-xl-none">
            <div class="d-flex justify-content-center align-items-center mobile-table-row" [class.isLastRow]="isLast">
              <div class="flex-grow-1">
                <div class="d-flex flex-column" [class.isLastRow]="isLast">
                  <div>
                    <div *ngTemplateOutlet="userAvatarTemplate; context: {user: request.userDetail}"></div>
                  </div>
                  <div>
                    <strong>{{ t("request.category") }}:</strong>{{ " " + t("request.type." + request.type) }}
                  </div>
<!--                  <div>-->
<!--                    <strong>{{ t("request.organiser.name") }}:</strong> {{ " " + getOrganiserNameColumn(request) }}-->
<!--                  </div>-->
                  <div>
                    <strong>{{ t("event.item.name") }}:</strong>
                    @if (request.event) {
                      <app-language-output [hrLabel]="request.event?.name" [enLabel]="request.event?.nameEng"
                                           [itLabel]="request.event?.nameIta" [siLabel]="request.event?.nameSlo"
                                           [defaultLanguage]="request.event?.defaultLanguage" [languages]="languages"/>
                    } @else {
                      {{ "" }}
                    }
                  </div>
                  <div>
                    <strong>{{ t("request.date.created") }}:</strong> {{
                      " " + request.created|
                        localizedDate:'short'
                    }}
                  </div>
                  <div>
                    <strong>{{ t("request.status") }}:</strong>{{ " " + t("request.status." + request.requestStatus) }}
                  </div>
                </div>
              </div>
              @if (request.type !== RequestTypes.ADD_EVENT_TO_LEAGUE || actionsAllowed(request)) {
                <div>
                  <div ngbDropdown class="dropdown dropdown--remove-arrow" container="body">
              <span class="menu-icon" id="requestActionsDropdownMobile" ngbDropdownToggle>
                <i class="fas fa-ellipsis-v"></i>
              </span>
                    <ul aria-labelledby="requestActionsDropdownMobile" ngbDropdownMenu>
                      @if (request.type !== RequestTypes.ADD_EVENT_TO_LEAGUE) {
                        <li ngbDropdownItem (click)="openRequestDetails(request)">
                          {{ t("app.common.details") }}
                        </li>
                      }
                      @if (actionsAllowed(request)) {
                        <li ngbDropdownItem (click)="openModifyRequestDialog(request, true)">
                          {{ t("request.action.accept") }}
                        </li>
                      }
                      @if (actionsAllowed(request)) {
                        <li ngbDropdownItem (click)="openModifyRequestDialog(request, false)">
                          {{ t("request.action.decline") }}
                        </li>
                      }
                    </ul>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>
    } @else {
      <div class="pt-2 pb-4">
        <app-empty-state/>
      </div>
    }
    @if (hasMore) {
      <div class="d-flex justify-content-center load-more-wrapper pt-2 pb-2">
        <app-rounded-button [label]="t('app.common.load.more')" (onClick)="loadMore()"/>
      </div>
    }
    @if (showFabButton && (requests?.length ?? 0) > 0) {
      <div (click)="scrollToTop()" class="scroll-to-top">
        <i class="bi bi-arrow-up"></i>
      </div>
    }
  </div>
</ng-container>

<ng-template #userAvatarTemplate let-user="user">
  <div class="circle me-2">
    <ng-container *ngIf="user.picture; else noPicture">
      <img [src]="user.picture">
    </ng-container>
    <ng-template #noPicture>
      <p>
        {{ user.firstname?.charAt(0)?.toUpperCase() }}{{ user.lastname?.charAt(0)?.toUpperCase() }}
      </p>
    </ng-template>
  </div>
</ng-template>
